import React, {useRef, useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Button} from '../Button/index.js';
import {Card} from '../Card/index.js';
import {Text} from '../Text/index.js';
import "./index.css";


export default (props) => {
  
  const ref = useRef();
  
  const [pos, setPos] = useState({});
  useEffect(() => {
    const rect = ref.current.getBoundingClientRect();
    setPos({
      top: rect.top + ref.current.offsetHeight,
      left: rect.left
    });
  }, []);
  
  const [open, setOpen] = useState(false);
  
  function select(option) {
    const val = props.value.split(',').map(v => v.trim()).filter(v => !!v);
    const i = val.indexOf(option);
    if(i > -1) {
      val.splice(i, 1);
    }
    else {
      val.push(option);
    }
    props.onChange(val.join(', '));
  }
  
  const selectedOptions = props.options.filter(o => props.value.indexOf(o.value) > -1);
  
  const menu = !open ? null : ReactDOM.createPortal(
    <div key="menu" className="select-overlay" onClick={() => setOpen(false)}>
      <Card style={{...pos}} className="select-card">
        {props.options.map(option => 
          <Button
            block
            key={option.key || option.value}
            label={
              <div style={{display:'flex', alignItems:'baseline', color: selectedOptions.includes(option) ? props.selectedColor || "#aaa" : "#424242"}}>
                <div 
                  style={{
                    width:12,
                    height: 12,
                    marginRight: 8,
                    position: 'relative',
                    top: 2,
                    border: "2px solid currentColor",
                    backgroundColor: selectedOptions.includes(option) ? "currentColor" : "transparent"
                  }}
                />
                <div>
                  {option.label}
                </div>
              </div>
            }
            onClick={(e) => {
              e.stopPropagation();
              select(option.value);
            }}
          />
        )}
      </Card>
    </div>, 
    document.body
  );
  
  const value = selectedOptions && selectedOptions.length === 1 ? selectedOptions[0].label :
                selectedOptions && selectedOptions.length > 1 ? `${selectedOptions[0].label} +${selectedOptions.length - 1}` :
                props.placeholder ? props.placeholder :
                "";
  
  const input = (
    <div 
      ref={ref} 
      key="input" 
      className={`select-input ${props.large ? 'large' : ''}`} 
      onClick={() => setOpen(true)} 
      style={props.style}>
      
      <Text block style={{width:'100%', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{value}</Text>
      <svg height="6px" viewBox="0 0 9.94 7.56" className="select-caret">
        <polyline fill="#aaaaaa" points="9.94,0 4.97,7.56 0,0 "/>
      </svg>
      
    </div>
  );
  
  return [input, menu];
};
